import { Language } from 'assets/locales/Locale';
import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import Model from 'models/Model';
import ProductRefundFillablePdfField from '../productRefundFillablePdfField/Model.ProductRefundFillablePdfField';
import productRefundDocumentFindApi from './find/Api.ProductRefundDocument.Find';
import productRefundDocumentSaveApi from './save/Api.ProductRefundDocument.Save';
import productRefundDocumentDeleteApi from './delete/Api.ProductRefundDocument.Delete';

export default class ProductRefundDocument
  extends Model<Model.IProductRefundDocument>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProductRefundDocument>
{
  id: number;
  productId: number;
  orderNumber: number;
  mediaFileId: number;
  mediaFile: MediaFile;
  formFile?: File;
  documentCategory: Model.Enum.EngineType;
  fillablePdfFields: Array<ProductRefundFillablePdfField>;
  languageIsoCode?: Locale.Languages = Language.english;

  constructor(
    data: Partial<Model.IProductRefundDocument> | Utils.FormData<Model.IProductRefundDocument>,
    language?: Locale.Languages
  ) {
    super(
      {
        mediaFile: MediaFile,
        fillablePdfFields: [ProductRefundFillablePdfField],
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.mediaFile?.name || this.id.toString(),
    };
  }
  static async find(params: Api.Core.ProductRefundDocument.Find.IRequest) {
    const { payload, ...rest } = await productRefundDocumentFindApi(params);
    return {
      ...rest,
      payload: payload ? new ProductRefundDocument(payload) : null,
    };
  }
  async save() {
    return await productRefundDocumentSaveApi(this);
  }
  async delete() {
    return await productRefundDocumentDeleteApi({ productId: this.productId, documentId: this.id });
  }
}
